import React, { createContext, FC, ReactNode, useContext } from "react";

const CategoryCollectionCustomerContext = createContext<string | undefined>(
  undefined
);

export const CategoryCollectionCustomerProvider: FC<{
  customerId?: string;
  children: ReactNode;
}> = ({ customerId, children }) => (
  <CategoryCollectionCustomerContext.Provider value={customerId}>
    {children}
  </CategoryCollectionCustomerContext.Provider>
);

export const useCategoryCollectionCustomerId = (): string | undefined =>
  useContext(CategoryCollectionCustomerContext);
